let dragdrop = require('./dragdrop');
let builder = require('../builder-componenets');
let fieldManager = require('./fields');
let propertiesManager = require('./properties');

module.exports = {
    bindPropsToNewSection() {

        let _this = this;

        let $body = $('body');

        if ($('.create-field').length) {
            $('.nav-link').on('click', function (e) {
                e.preventDefault();
                let id = $(this).data('id');
                $('input[name="section"]').val(id);
                $('html, body').animate({scrollTop: $(`#${id}`).offset().top - 200}, 'slow');
                $('.nav-link').removeClass('active');
                $(this).addClass('active');

                if (is_mobile) {
                    let text = $(this).text().trim();
                    $(this).parents('.section-link-container').find('.dropdown-toggle').text(text);
                }
            });
        }

        $body.on('change', '.sectionEdit', function () {
            let value = $(this).is(':checked'),
                $activeSection = $body.find('.activeSection');

            $activeSection.data('allow-edit', value ? 0 : 1);
            $activeSection.attr('data-allow-edit', value ? 0 : 1);
        });

        $body.on('change', '.sectionDisableLink', function () {
            let value = $(this).is(':checked'),
                $activeSection = $body.find('.activeSection');

            $activeSection.data('disable-related-hyperlink', value ? 1 : 0);
            $activeSection.attr('data-disable-related-hyperlink', value ? 1 : 0);
        });

        $body.on('change', '.toggleSectionCounter', function () {
            let value = $(this).is(':checked'),
                $activeSection = $body.find('.activeSection');

            $activeSection.data('enable-counter', value ? 1 : 0);
            $activeSection.attr('data-enable-counter', value ? 1 : 0);
        });

        $body.on('change', '.allowScroll', function () {
            let value = $(this).is(':checked'),
                $activeSection = $body.find('.activeSection');

            $activeSection.data('allow-scroll', value ? 1 : 0);
            $activeSection.attr('data-allow-scroll', value ? 1 : 0);
        });

        $body.on('change', '.fullText', function () {
            let value = $(this).is(':checked'),
                $activeSection = $body.find('.activeSection');

            $activeSection.data('full-text', value ? 1 : 0);
            $activeSection.attr('data-full-text', value ? 1 : 0);
        });

        $body.on('keyup', '.sectionLabel', function () {
            let value = $(this).val(),
                type = $(this).data('type'),
                $activeSection = $body.find('.activeSection'),
                name = value.replace(/\s/g, "_").toLowerCase();

            $activeSection.data('section-label', value);

            if (!$activeSection.data('section-id')) {

                if (tenant !== 'default' && name.length && !name.endsWith('_c')) {
                    name = `${name}_c`;
                } else if (tenant !== 'default' && !name.length) {
                    name = `_c`;
                }

                $body.find('.sectionName').val(name);
                $activeSection.data('section-name', name);
            }
            $activeSection.find('.card-title').text(value);
        });

        $body.on('keyup', '.sectionName', function () {
            let value = $(this).val();
            value = value.replace(/\s/g, "_").toLowerCase();

            if (tenant !== 'default' && !value.length && !value.endsWith('_c')) {
                value = `${value}_c`;
            }
            $body.find('.sectionName').val(value);
            $('body').find('.activeSection').data('section-name', value);
        });

        $body.on('keyup', '.section-no-of-records', function () {
            let value = $(this).val();
            $('body').find('.activeSection').data('no-of-records', value);
        });

        $body.on('change', '.related-table', function (e) {
            let value = $(this).val();
            let $activeSection = $('body').find('.activeSection');
            if (!$activeSection.data('last-related-to')) {
                let related_to = $activeSection.data('related-to'),
                    visible_fields = JSON.stringify($activeSection.data('visible-fields')),
                    hidden_fields = JSON.stringify($activeSection.data('hidden-fields'));
                $activeSection.data('last-related-to', related_to).attr('last-related-to', related_to);
                $activeSection.data('last-visible-fields', visible_fields).attr('data-last-visible-fields', visible_fields);
                $activeSection.data('last-hidden-fields', hidden_fields).attr('data-last-hidden-fields', hidden_fields);
            }
            $activeSection.data('related-to', value).attr('data-related-to', value);
            if (value.length && $activeSection.attr('last-related-to') !== value) {
                _this.populateColumnsForRelatedTable(value);
            } else {
                _this.addFieldsToRelatedProperties(
                    value,
                    null,
                    ['data-last-visible-fields', 'data-last-hidden-fields']
                );
            }
            _this.populateRelatedSectionTableFilters(value);
            $('.primary-key-holder').find('.primary-key').empty();
            $('.add-fetch-keys').trigger('click');
        });

        $body.on('change', '.related-table-filter', function (e) {
            let value = $(this).val();
            let $activeSection = $('body').find('.activeSection');
            $activeSection.data('filter', value).attr('data-filter', value);
        });

        $body.on('click', '.add-fetch-keys', (e) => {
            let related_table = $('.related-table').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.primary-key').find('.row').length === 0 ? 'yes' : 'no',
                row_count = $('.primary-key').find('.single-primary-key').length;

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/section/primary_key',
                data: {
                    related_table: related_table,
                    curr_table: curr_table,
                    header: header,
                    row_count,
                    type: 'fetch_keys',
                    show_conditions: 1
                },
                success: (res) => {
                    $('.primary-key-holder').find('.primary-key').append(res);

                    // Check the row count after appending the new primary key row
                    row_count = $('.primary-key').find('.single-primary-key').length;

                    if (row_count > 1) {
                        $('.primary-key-holder').find('.primary-condition').each(function(index) {
                            if (index !== 0) { // Skip the first .primary-condition
                                $(this).removeClass('d-none');
                            }
                        });
                    } else {
                        $('.primary-key-holder').find('.primary-condition').addClass('d-none');
                    }
                }
            });
        });

        // $body.on('click', '.add-save-keys', (e) => {
        //     let related_table = $('.related-table').val(),
        //         curr_table = $('.builder-main').data('id'),
        //         header = $('.save-keys').find('.row').length === 0 ? 'yes' : 'no';
        //
        //     $.ajax({
        //         type: 'GET',
        //         url: '/tablebuilder/section/primary_key',
        //         data: {
        //             related_table: related_table,
        //             curr_table: curr_table,
        //             header: header,
        //             type: 'save_keys'
        //         },
        //         success: (res) => {
        //             $('.save-keys-holder').find('.save-keys').append(res);
        //             this.handleSaveKeyChange();
        //         }
        //     });
        // });

        $body.on('change', '.current-primary-key, .related-primary-key', this.handleKeyChanges.bind(this));

        $body.on('mouseenter', '.primary-arrow', function (e) {
            $(this).removeClass('fa-long-arrow-alt-left').addClass('fa-trash-alt');
        });

        $body.on('mouseout', '.primary-arrow', function (e) {
            $(this).removeClass('fa-trash-alt').addClass('fa-long-arrow-alt-left');
        });

        $body.on('click', '.remove-primary > .fas', function (e) {
            $(this).parents('.single-primary-key').remove();

            // Handle key changes
            _this.handleKeyChanges();

            // Update row count after removing a primary key row
            let row_count = $('.primary-key').find('.single-primary-key').length;

            if (row_count > 1) {
                $('.primary-key-holder').find('.primary-condition').each(function(index) {
                    if (index !== 0) { // Skip the first .primary-condition
                        $(this).removeClass('d-none');
                    }
                });
            } else {
                $('.primary-key-holder').find('.primary-condition').addClass('d-none');
            }
        });

        $body.on('click', '.primary-condition', function (e) {
            let value = $(this).attr('data-condition');

            if(value === 'AND'){
                $(this).attr('data-condition', 'OR').text('OR');
            }else if(value === 'OR'){
                $(this).attr('data-condition', 'AND').text('AND');
            }

            // Handle key changes
            _this.handleKeyChanges();
        });

        $body.on('click', '.section-visibility', function (e) {
            let id = $(this).attr('data-id'),
                show = $(this).data('visibility') === 1 ? 0 : 1;

            $(this).data('visibility', show);

            if (show) {
                $(this).removeClass('fa-eye-slash').addClass('fa-eye');
            } else {
                $(this).removeClass('fa-eye').addClass('fa-eye-slash');
            }

            $.ajax({
                type: 'POST',
                url: '/tablebuilder/section/visibility',
                data: {
                    id,
                    visibility: show
                },
                success: function (res) {
                    toastr.success(translation.section_visibility_updated);
                }
            });
        });

        $body.on('click', '.lock-section', function (e) {
            let id = $(this).attr('data-id'),
                is_default = $(this).data('default') === 1 ? 0 : 1,
                $deleteBtn = $(this).siblings('.deleteSection');

            $(this).data('default', is_default);

            if (is_default) {
                $(this).removeClass('fa-unlock').addClass('fa-lock');
                $deleteBtn.addClass('d-none');
            } else {
                $(this).removeClass('fa-lock').addClass('fa-unlock');
                $deleteBtn.removeClass('d-none');
            }

            $.ajax({
                type: 'POST',
                url: '/tablebuilder/section/lock',
                data: {
                    id,
                    is_default: is_default
                },
                success: function (res) {
                    toastr.success(translation.section_updated);
                }
            });
        });

        $body.on('click', '.lock-field', function (e) {
            let id = $(this).attr('data-id'),
                is_default = $(this).data('default') === 1 ? 0 : 1,
                $deleteBtn = $(this).parents('.field-controllers').find('.deleteField');

            $(this).data('default', is_default);

            if (is_default) {
                $(this).removeClass('fa-unlock').addClass('fa-lock');
                $deleteBtn.addClass('d-none');
            } else {
                $(this).removeClass('fa-lock').addClass('fa-unlock');
                $deleteBtn.removeClass('d-none');
            }

            $.ajax({
                type: 'POST',
                url: '/tablebuilder/section/field/lock',
                data: {
                    id,
                    is_default: is_default
                },
                success: function (res) {
                    toastr.success(translation.field_updated);
                }
            });
        });

    },

    populateRelatedSectionTableFilters(table_id) {
        $.ajax({
            type: 'GET',
            url: '/tablebuilder/table/filters',
            data: {
                id: table_id
            },
            success: (filters) => {
                let filterOptions = '<option value="">Select Filter</option>',
                    $activeSection = $('.related-section.activeSection');
                if (filters) {
                    for (let key in filters) {
                        if (filters.hasOwnProperty(key)) {
                            filterOptions += `<option value="${key}">${filters[key]}</option>`;
                        }
                    }
                }
                $('.related-table-filter').html(filterOptions).trigger('change');
                $activeSection.attr('data-table-filters', JSON.stringify(filters)).data('table-filters', filters);
            }
        })
    },

    handleKeyChanges(e = null) {
        if (e) {
            e.preventDefault();
        }
        this.handlePrimaryKeyChange();
        this.handleSaveKeyChange();
        propertiesManager.handleRelationKeyChange();
    },

    handlePrimaryKeyChange() {

        let $mappings = $('.primary-key-holder').find('.single-primary-key'),
            keys = [];

        $mappings.each((index, $mapping) => {
            let current_table_field = $($mapping).find('.current-primary-key').val(),
                related_table_field = $($mapping).find('.related-primary-key').val(),
                condition = $($mapping).find('.primary-condition').attr('data-condition');

            let key = [current_table_field, related_table_field, condition];
            keys.push(key);
        });

        $('body')
            .find('.activeSection')
            .attr('data-primary-key', JSON.stringify(keys))
            .data('primary-key', keys);
    },

    handleSaveKeyChange() {
        let $mappings = $('.save-keys-holder').find('.single-primary-key'),
            keys = [];

        $mappings.each((index, $mapping) => {
            let current_table_field = $($mapping).find('.current-primary-key').val(),
                related_table_field = $($mapping).find('.related-primary-key').val();

            let key = [current_table_field, related_table_field];
            keys.push(key);
        });

        $('body')
            .find('.activeSection')
            .attr('data-save-keys', JSON.stringify(keys))
            .data('save-keys', keys);
    },

    renderPrimaryKeys(keys) {
        if (keys.length) {
            let related_table = $('.related-table').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.primary-key').find('.row').length === 0 ? 'yes' : 'no',
                row_count = $('.primary-key').find('.single-primary-key').length;

            if (header === 'yes') {
                $.ajax({
                    type: 'GET',
                    url: '/tablebuilder/section/primary_key',
                    data: {
                        related_table: related_table,
                        curr_table: curr_table,
                        primary_keys: keys,
                        header: header,
                        row_count,
                        type: 'fetch_keys',
                        show_conditions : 1
                    },
                    success: (res) => {
                        $('.primary-key-holder').find('.primary-key').empty().append(res);
                    }
                });
            }
        }
    },

    renderSaveKeys(keys) {
        if (keys.length) {
            let related_table = $('.related-table').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.save-keys').find('.row').length === 0 ? 'yes' : 'no';

            if (header === 'yes') {
                $.ajax({
                    type: 'GET',
                    url: '/tablebuilder/section/primary_key',
                    data: {
                        related_table: related_table,
                        curr_table: curr_table,
                        primary_keys: keys,
                        header: header,
                        type: 'save_keys'
                    },
                    success: (res) => {
                        $('.save-keys-holder').find('.save-keys').empty().append(res);
                    }
                });
            }
        }
    },

    updateAttributes() {
        $('.table-section').each(function (i, $table_section) {
            let $section = $($table_section);
            if ($section.attr('data-related-to')) {
                $section.data('last-related-to', $section.data('related-to')).attr('last-related-to', $section.data('related-to'));
                $section.data('last-visible-fields', JSON.stringify($section.data('visible-fields'))).attr('data-last-visible-fields', JSON.stringify($section.data('visible-fields')));
                $section.data('last-hidden-fields', JSON.stringify($section.data('hidden-fields'))).attr('data-last-hidden-fields', JSON.stringify($section.data('hidden-fields')));
            }
        });
    },

    populateColumnsForRelatedTable(table_id, order_ids = null) {
        $.ajax({
            type: 'GET',
            url: '/tablebuilder/table/fields',
            data: {
                id: table_id,
                order_ids: order_ids
            },
            success: (fields) => {
                this.addFieldsToRelatedProperties(table_id, fields);
            }
        })
    },

    addFieldsToRelatedProperties(table_id, fields, attrs = []) {
        $('.hidden-fields').empty();
        $('.visible-fields').empty();

        if (!fields) {
            fields = {
                visible: JSON.parse($('body').find('.activeSection').attr(attrs[0])),
                hidden: JSON.parse($('body').find('.activeSection').attr(attrs[1]))
            };

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields',
                data: {
                    id: table_id,
                    fields
                },
                success: (fields) => {
                    let hidden_columns = '',
                        visible_columns = '';
                    $(fields.visible).each(function (i, item) {
                        visible_columns += `<p class="filed_name mb-1" data-id="${item.id}">${item.label}</p>`;
                    });

                    $(fields.hidden).each(function (i, item) {
                        hidden_columns += `<p class="filed_name mb-1" data-id="${item.id}">${item.label}</p>`;
                    });

                    $(visible_columns).appendTo('.visible-fields');
                    $(hidden_columns).appendTo('.hidden-fields');

                    this.setColumnAttributes();

                    $(".visible-fields , .hidden-fields").sortable({
                        items: "p",
                        connectWith: ".connectedSortable",
                        cursor: "grabbing",
                        stop: (event, ui) => {
                            this.setColumnAttributes();
                        }
                    }).disableSelection();
                }
            })
        } else {
            let hidden_columns = '',
                visible_columns = '';
            $(fields).each(function (i, item) {
                if (item.is_hidden === 1) {
                    hidden_columns += `<p class="filed_name mb-1" data-id="${item.id}">${item.label}</p>`;
                }
                if (item.is_hidden === 0) {
                    visible_columns += `<p class="filed_name mb-1" data-id="${item.id}">${item.label}</p>`;
                }
            });

            $(visible_columns).appendTo('.visible-fields');
            $(hidden_columns).appendTo('.hidden-fields');

            this.setColumnAttributes();

            $(".visible-fields , .hidden-fields").sortable({
                items: "p",
                connectWith: ".connectedSortable",
                cursor: "grabbing",
                stop: (event, ui) => {
                    this.setColumnAttributes();
                }
            }).disableSelection();
        }
    },

    setColumnAttributes() {
        let hidden_fields = [],
            related_table = $('.related-table').val(),
            $activeSection = $('body').find('.activeSection');

        $('.hidden-fields > p').each(function (i, item) {
            hidden_fields.push($(item).data('id'));
        });

        let visible_fields = [];
        $('.visible-fields > p').each(function (i, item) {
            visible_fields.push($(item).data('id'));
        });

        $activeSection.attr('data-visible-fields', JSON.stringify(visible_fields)).data('visible-fields', visible_fields);
        $activeSection.attr('data-hidden-fields', JSON.stringify(hidden_fields)).data('hidden-fields', hidden_fields);

        if (related_table === $activeSection.attr('last-related-to')) {
            $activeSection.attr('data-last-visible-fields', JSON.stringify(visible_fields));
            $activeSection.attr('data-last-hidden-fields', JSON.stringify(hidden_fields));
        }

    },

    addNewSection() {

        let propsContent = $('.propertiesContent');
        let addSec = $('.addNewSection');
        let content = '';

        addSec.on('click', function (e) {

            e.preventDefault();

            $('body').find('.fieldsSection').removeClass('activeSection');

            $('.tab-control').removeClass('active');
            $('.propertiesTabHeader').addClass('active');

            let order = $('body').find('.fieldsSection').length + 1;

            content += `<div class="row table-section mb-4 fieldsSection activeSection"
                            data-section-order="${order}"
                            data-section-label=""
                            data-section-name=""
                            data-allow-edit="0"
                            data-disable-related-hyperlink="0"
                            data-allow-scroll="0"
                            data-full-text="0"
                            data-no-of-records="10"
                            data-section-id="">
                            <div class="col-sm-7 mx-auto card" >
                                <div class="card-header">
                                    <a
                                        href="#"
                                        class="sectionTitle">
                                        <h5 class="card-title">Untitled</h5>
                                    </a>
                                    <a href="#" class="del-controller deleteSection">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </div>
                                <div class="card-body sectionBody emptySectionBody"> </div>
                            </div>
                        </div>`;

            $(content).insertBefore('.builder-main .addSecBtn');
            dragdrop.attachDroppable('.sectionBody:not(.related-section-body)')
            propsContent.html(builder.newSectionProperties());
            fieldManager.manageFieldsProps();
            content = '';
            $('body').find('.propsControl').removeClass('activeField');
        })
    },

    getClickedSectionProps() {
        let _this = this;
        let propsContent = $('.propertiesContent');
        let title, name, label, secName;

        $('body').on('click', '.sectionTitle', function (e) {
            let $section = $(this).parents('.fieldsSection');
            e.preventDefault();

            $('.tab-control').removeClass('active');
            $('.propertiesTabHeader').addClass('active');

            $('body').find('.fieldsSection').removeClass('activeSection');

            if ($(this).parents('.fieldsSection').hasClass('related-section')) {

                let $parent = $(this).parents('.fieldsSection'),
                    related_to = $parent.data('related-to'),
                    filter = $parent.data('filter'),
                    table_filters = $parent.data('table-filters'),
                    primary_key = $parent.data('primary-key'),
                    save_keys = $parent.data('save-keys'),
                    allow_edit = $parent.data('allow-edit'),
                    disable_related_hyperlink = $parent.data('disable-related-hyperlink'),
                    enable_counter = $parent.data('enable-counter'),
                    allow_scroll = $parent.data('allow-scroll'),
                    no_of_records = $parent.data('no-of-records'),
                    full_text = $parent.data('full-text');

                let tbOptions = '',
                    filterOptions = '';
                $.get("/get-all-tables", data => {
                    for (let table of data) {
                        tbOptions += `<option value="${table.id}" ${table.id === parseInt(related_to) ? 'selected' : ''}>${table.label}</option>`;
                    }

                    if (table_filters) {
                        for (let key in table_filters) {
                            if (table_filters.hasOwnProperty(key)) {
                                filterOptions += `<option value="${key}" ${parseInt(key) === parseInt(filter) ? 'selected' : ''}>${table_filters[key]}</option>`;
                            }
                        }
                    }

                    $(this).parents('.fieldsSection').addClass('activeSection');
                    label = $(this).parents('.fieldsSection').data('section-label');
                    secName = $(this).parents('.fieldsSection').data('section-name');
                    title = (label != null) ? label : 'Untitled';
                    name = (secName != null) ? secName : 'Untitled';
                    propsContent.html(builder.newRelatedSectionProperties(tbOptions, filterOptions));
                    fieldManager.manageFieldsProps();
                    $('body').find('.sectionLabel').val(title);
                    $('body').find('.sectionName').val(name);
                    $('body').find('.section-no-of-records').val(no_of_records);
                    $('body').find('.sectionEdit').prop('checked', allow_edit ? false : true);
                    $('body').find('.sectionDisableLink').prop('checked', disable_related_hyperlink ? true : false);
                    $('body').find('.allowScroll').prop('checked', allow_scroll ? true : false);
                    $('body').find('.fullText').prop('checked', full_text ? true : false);
                    $('body').find('.toggleSectionCounter').prop('checked', enable_counter ? true : false);
                    _this.addFieldsToRelatedProperties(
                        $('.related-table').val(),
                        null,
                        ['data-visible-fields', 'data-hidden-fields']
                    );
                    _this.renderPrimaryKeys(primary_key);
                    // _this.renderSaveKeys(save_keys);

                    if ($section.attr('data-section-id')) {
                        $('body').find('.sectionName').attr('readonly', true);
                    }
                });
            } else {
                $(this).parents('.fieldsSection').addClass('activeSection');
                label = $(this).parents('.fieldsSection').data('section-label');
                secName = $(this).parents('.fieldsSection').data('section-name');
                title = (label != null) ? label : 'Untitled';
                name = (secName != null) ? secName : 'Untitled';
                propsContent.html(builder.newSectionProperties());
                fieldManager.manageFieldsProps();

                $('body').find('.sectionLabel').val(title);
                $('body').find('.sectionName').val(name);

                if ($section.attr('data-section-id')) {
                    $('body').find('.sectionName').attr('readonly', true);
                }
            }
        })
    },

    orderSection() {

        $(".builder-main").sortable({
            containment: "document",
            items: '.fieldsSection',
            handle: ".sectionTitle",
            tolerance: "pointer",
            cursor: "move",
            opacity: 0.5,
            revert: 300,
            delay: 150,
            placeholder: "movable-placeholder",
            update: function (e, ui) {
                let sibItems = ui.item.siblings();
                // Change order of the item based on Index
                ui.item.data('section-order', ui.item.index() + 1)
                // Change siblings index
                sibItems.each(function (i, u) {
                    $(this).data('section-order', i + 1)
                })
            }
        });
        $(".builder-main .fieldsSection").disableSelection();
    }
};